{
  "level": "p_in02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:p_in02",
    "objects": "AREAS.E3:p_in02.e3",
    "mesh": "TREES.E3:p_in02.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1.5,
        -1.5,
        0.0
      ],
      "bbox_max": [
        1.5,
        1.5,
        0.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "C:\\EDITOR\\ground.lwo",
      "entity_class": "C:\\EDITOR\\ground.lwo",
      "piece_name": "",
      "offset": 54,
      "centroid": [
        0.0,
        0.0,
        0.0
      ],
      "bbox_min": [
        -1.5,
        -1.5,
        0.0
      ],
      "bbox_max": [
        1.5,
        1.5,
        0.0
      ],
      "dimensions_source": {
        "span_x": 3.0,
        "span_y": 3.0,
        "height_z": 0.0,
        "door_width": 3.0,
        "door_depth": 3.0,
        "leaf_depth": 3.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -1.5,
          -1.5,
          0.0
        ],
        [
          1.5,
          1.5,
          0.0
        ],
        [
          -1.5,
          1.5,
          0.0
        ],
        [
          1.5,
          -1.5,
          0.0
        ]
      ],
      "plane_distance": 0.0
    },
    {
      "tag": "C:\\EDITOR\\ground.lwo",
      "entity_class": "C:\\EDITOR\\ground.lwo",
      "piece_name": "",
      "offset": 5705,
      "centroid": [
        0.0,
        0.0,
        0.0
      ],
      "bbox_min": [
        -1.5,
        -1.5,
        0.0
      ],
      "bbox_max": [
        1.5,
        1.5,
        0.0
      ],
      "dimensions_source": {
        "span_x": 3.0,
        "span_y": 3.0,
        "height_z": 0.0,
        "door_width": 3.0,
        "door_depth": 3.0,
        "leaf_depth": 3.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -1.5,
          -1.5,
          0.0
        ],
        [
          1.5,
          1.5,
          0.0
        ],
        [
          -1.5,
          1.5,
          0.0
        ],
        [
          1.5,
          -1.5,
          0.0
        ]
      ],
      "plane_distance": 0.0
    }
  ],
  "tutorial_messages": []
}